export const noFollowProp = (nofollow) => (nofollow ? { rel: 'nofollow' } : {});

export const targetProp = (link) => {
  if (!link?.startsWith('http')) return {};

  const url = new URL(link);
  const params = new URLSearchParams(url.search);
  return params.has('open_in_new_tab') ? { target: '_blank' } : {};
};
